export default {
  BASKET: {
    EDIT: 'checkout_edit_basket',
  },
  COLLECTION: {
    CONTINUE_TO_PAYMENT: 'checkout_collection_continue_to_payment',
  },
  DELIVERY: {
    CONTINUE_TO_PAYMENT: 'checkout_delivery_continue_to_payment',
    VIEW_MORE_OPTIONS: 'checkout_delivery_view_more_delivery_options',
  },
  ITEM: {
    REMOVE: 'checkout_item_remove',
    SAVE_FOR_LATER: 'checkout_item_sfl',
    ZOOM_IMAGE: 'checkout_item_zoom_image',
  },
  ORDER_CONFIRMATION: {
    ONE4ALL: {
      BIN_DETECTED: 'checkout_one4all_bin',
    },
    SPLIT_DELIVERY_MESSAGE: {
      ORDER_COMPLETE: 'checkout_split_delivery_message_order_complete',
      ORDER_AMENDED: 'checkout_split_delivery_message_order_amended',
    },
  },
  PAYMENT: {
    BARCLAYS: {
      AUTHENTICATION_TRIGGERED: 'checkout_barclays_authentication_triggered',
      AUTHORISATION_DECLINE: 'checkout_barclays_authorisation_decline',
      AUTHORISATION_SUCCESS: 'checkout_barclays_authorisation_success',
      CHALLENGE_FAILURE: 'checkout_barclays_challenge_failure',
      CHALLENGE_SUCCESS: 'checkout_barclays_challenge_success',
      CHALLENGE_TRIGGERED: 'checkout_barclays_challenge_triggered',
      PAYMENT_START: 'checkout_barclays_payment_start',
      TRA: 'checkout_barclays_TRA',
    },
    ENTIRELY_GIFT_CARD: 'checkout_entirely_gift_card',
    ENTIRELY_VOUCHER: 'checkout_entirely_voucher',
    ONE4ALL: {
      MODAL_CLICK: 'checkout_one4all_modal_clicks',
    },
    PLACE_ORDER: {
      KLARNA: 'checkout_klarna_place_order',
      POSC: 'checkout_posc_place_order',
      POSC_DEFERRED_IBC: 'checkout_bnpl_place_order',
      POSC_IBC: 'checkout_ibc_place_order',
      POSC_IFC: 'checkout_ifc_place_order',
    },
    SAVED_CARD_CVV_VISIBLE: 'checkout_payment_saved_card_cvv_visible',
    SELECTED: {
      POSC: 'checkout_posc_selected',
      POSC_DEFERRED_IBC: 'checkout_bnpl_selected',
      POSC_IBC: 'checkout_ibc_selected',
      POSC_IFC: 'checkout_ifc_selected',
    },
    STRIPE: {
      AUTHORISATION_DECLINE: 'checkout_stripe_authorisation_decline',
      AUTHORISATION_SUCCESS: 'checkout_stripe_authorisation_success',
      CHALLENGE_FAILURE: 'checkout_stripe_challenge_failure',
      CHALLENGE_SUCCESS: 'checkout_stripe_challenge_success',
      CHALLENGE_TRIGGERED: 'checkout_stripe_challenge_triggered',
      PAYMENT_START: 'checkout_stripe_payment_start',
    },
  },
  SESSION: {
    TIMEOUT: 'checkout_session_timeout',
    TIMEOUT_MODAL_DISPLAYED: 'checkout_session_timeout_modal_displayed',
    TIMEOUT_RESTART_CLICK: 'checkout_session_timeout_restart_click',
  },
  WALLET: {
    APPLE_PAY: {
      ELIGIBLE: 'checkout_apple_pay_is_eligible',
    },
    GOOGLE_PAY: {
      ELIGIBLE: 'checkout_google_pay_is_eligible',
    },
    KLARNA: {
      ELIGIBLE: 'checkout_klarna_is_eligible',
    },
    LINK: {
      ELIGIBLE: 'checkout_link_is_eligible',
    },
  },
};
